module.exports = __webpack_public_path__ + "static/media/26UNRWA24.b7473886.jpg";